import {Document, Page, View, Font, Text, Image} from "@react-pdf/renderer";
import RubikLight from "../../../../../../fonts/Rubik-Light.ttf";
import RubikRegular from "../../../../../../fonts/Rubik-Regular.ttf";
import RubikMedium from "../../../../../../fonts/Rubik-Medium.ttf";
import RubikBold from "../../../../../../fonts/Rubik-Bold.ttf";
import RubikBlack from "../../../../../../fonts/Rubik-Black.ttf";
import {styles } from "../../StylesPdfReport";
import moment from "moment";
import CoverPage from "../../shared/pdf/CoverPage";
import AboutSection from "./AboutSection";
import Chart from "../../shared/pdf/Chart";
import ChartSubsection from "../../shared/pdf/ChartSubsection";
import Units from "../../shared/pdf/Units";
import MarkGroup from "../../shared/pdf/MarkGroup";
import TableRow from "../../shared/pdf/TableRow";
import ChartNoteWrapperBig from "../../shared/pdf/ChartNoteWrapperBig";
import SubcategorySection from "../../shared/pdf/SubcategorySection";
import {capitalize} from "@mui/material/utils";

Font.register({
    family: "Rubik",
    format: "truetype",
    fonts: [
        { src: RubikLight, fontWeight: 300 },
        { src: RubikRegular, fontWeight: 400 },
        { src: RubikMedium, fontWeight: 500 },
        { src: RubikBold, fontWeight: 700 },
        { src: RubikBlack, fontWeight: 800 },
    ],
});

const Report = ({ reportSummary, gradeLevels, graphData, skillsData }: any) => {

    return (
        <Document>
            <Page wrap size="A4" style={styles.body}>
                <View style={styles.coverBg}>
                    <CoverPage coverImage={reportSummary.coverImage} type="school">
                        <View style={styles.titleCover}>
                            <Text style={styles.h1}>Raport de evaluare</Text>
                            <Text style={styles.h2}>Sesiune #{reportSummary.testId}</Text>
                            <Text style={styles.h1}>Scor {reportSummary.score}</Text>
                            <Text style={styles.h2}>
                                {reportSummary.studentName && `Elev: ${reportSummary.studentName}`}
                            </Text>
                            <Text style={styles.h2}>
                                {reportSummary.testTitle !== null
                                    ? capitalize(reportSummary.testTitle)
                                    : reportSummary.testModeId < 3
                                        ? capitalize(reportSummary.type)
                                        : ""}
                                {" "}
                                {reportSummary.testModeId < 3 && (reportSummary.testGradeName === "I" ||
                                reportSummary.testGradeName === "0" ? reportSummary.testGradeName : `clasa a ${reportSummary.testGradeName}-a`)}
                                {reportSummary.testModeId >= 3 && reportSummary.testGradeName} |{" "}
                                {moment(reportSummary.testStartedAt).locale("ro").format("DD MMMM YYYY")}
                            </Text>
                        </View>
                    </CoverPage>
                    <View style={styles.wrapperCover}>
                        <AboutSection type={reportSummary.type} subject={reportSummary.subject}/>
                        <View break style={styles.sectionAbout}>
                            <Text style={styles.h1}>Despre Scorul BRIO</Text>
                            <Chart
                                left={reportSummary.graphLeft}
                                bottom={reportSummary.graphBottom}
                                testScore={reportSummary.score}
                                segmentsImage={reportSummary.graphSegmentsImage}
                                big={true}
                                type="school"
                            />
                            {!reportSummary.subjectsExcluded.includes(reportSummary.type) &&
                                gradeLevels.map((gradeLevel: any, index: any) => (
                                    <View key={index}>
                                        <ChartSubsection small={false} gradeLevel={gradeLevel} score={reportSummary.score} index={index} type="school" />
                                    </View>
                                ))
                            }
                        </View>
                        {graphData.length > 0 &&
                            <>
                                <View break style={styles.sectionAbout}>
                                    <Text style={styles.h1}>Profilul competențelor evaluate</Text>
                                    <View style={styles.tableNote}>
                                        <View style={{ position: "relative" }}>
                                            <MarkGroup type="school" />
                                            <View style={styles.gradesRow}>
                                                <View style={styles.colChapter}></View>
                                                <View style={[styles.colValues, { paddingBottom: "20pt" }]}>
                                                    <Units type="school"/>
                                                </View>
                                            </View>
                                            {graphData.map((section: any, index: any) => (
                                                <View key={index} >
                                                    <TableRow section={section} index={index} />
                                                </View>
                                            ))}
                                        </View>
                                        <View style={[styles.gradesRow, { border: "none", marginTop: "7pt" }]}>
                                            <View style={styles.colChapter}></View>
                                            <View style={styles.colValues}>
                                                <View>
                                                    <Image src="/images/reports/ld/chart-tabel.png" style={styles.chartTable} />
                                                    <Units type="school"/>
                                                    <ChartNoteWrapperBig big={false} type="school" />
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </>
                        }
                        <View style={styles.sectionAbout}>
                            {skillsData.length > 0 && (skillsData.map((skillData: any, index: any) => (
                                    <View key={index}>
                                        <SubcategorySection skillsData={skillData} key={index} type="school" small={false}/>
                                    </View>
                                ))
                            )}
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default Report;
